// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2wzFF","colMaxWidth":"Table_colMaxWidth__2RAFC"};